App.SmRestaurantMapComponent = Em.Component.extend
  classNames: ['restaurant-map']
  session: Em.inject.service()

  registerMap:(->
    return unless @$()?.get(0)
    unless window.mapgl
      setTimeout =>
        @registerMap()
      , 1000
      return

    restaurant = @get('restaurant')
    lat = restaurant.get('latitude')  || 55.754057
    lon = restaurant.get('longitude') || 37.622372
    coordinates = [lon, lat]
    mapOptions =
      zoom: 17
      center: coordinates
      disableDefaultUI: true
      zoomControl: true
      key: @get('session.twoGis_token')
      style: 'c080bb6a-8134-4993-93a1-5b4d8c36a59b'
    
    map = new mapgl.Map @$().get(0), mapOptions
    map.on 'click', (eventData) =>
      @coordinatesChange(eventData.lngLat, eventData)

    @set('restaurantMarker', Ember.Object.create())
    @set('map', map)
    @get('obtainDefers').forEach (defer) =>
      defer.resolve(map)
    @set 'animateNewMarkers', true
    @initMarkers(coordinates)
    @setCenter(coordinates)
  ).on('didInsertElement')

  initializeProps:( ->
    @set 'obtainDefers', Em.A([])
  ).on('init')

  coordinatesObserver: (->
    restaurant = @get('restaurant')
    lat = restaurant.get('latitude')  || 55.754057
    lon = restaurant.get('longitude') || 37.622372
    coordinates = [lon, lat]
    @coordinatesChange(coordinates)
    @setCenter(coordinates)
  ).observes('restaurant.mapLat', 'restaurant.mapLng')

  obtainMap: ->
    defer = Em.RSVP.defer()

    if @get 'initialized'
      defer.resolve @get('map')
    else
      @get('obtainDefers').pushObject defer
    defer.promise
  
  initMarkers: (coordinates)->
    restaurant = @get('restaurant')
    map = @get('map')
    icon = "images/map-markers/restaurant-marker.png"
    marker = new mapgl.Marker map,
      coordinates:  coordinates
      icon:         icon,
      size:         [28, 42]
      anchor:       [14, 42]
    @get('restaurantMarker').set(restaurant.get('id'), marker) if restaurant.get('id')
    

  setCenter: (coordinates) ->
    map = @get('map')
    map.setCenter(coordinates)
  
  
  coordinatesChange: (coordinates, eventData) ->
    restaurant = @get('restaurant')
    marker = @get('restaurantMarker').get(restaurant.get('id'))
    marker.setCoordinates(coordinates)

    [longitude, latitude] = coordinates

    restaurant.setProperties({
      longitude
      latitude
    })

    restaurant.reverseGeocode().then (data)=>
      restaurant.setProperties({
        skipGeocode: true
        city: data.suggestions.city
        address: data.suggestions.full_address
      })
      Em.run.next =>
        restaurant.set('skipGeocode', false)